import { 
    BusinessInteractEventDto, 
    BusinessEventParamsDto, 
    BusinessUserPropertiesDto,
    BusinessInteractPaymentEventDto,
    BusinessInteractPaymentEventParamsDto
} from "./interact_business.dto";
import { SHA256 } from "crypto-js";

export const BusinessInteractEvent = (data: any): BusinessInteractEventDto => {
    const { categoria, accion, etiqueta, micrositio, page_path, page_type, page_title, homemarket, login, user_props = {} } = data;
    const event_params = new BusinessEventParamsDto();
    event_params.evento_interactivo_categoria = categoria;
    event_params.evento_interactivo_accion = accion;
    event_params.evento_interactivo_etiqueta = etiqueta;
    event_params.micrositio = micrositio;
    event_params.page_path = page_path;
    event_params.page_type = page_type;
    event_params.page_title = page_title;
    event_params.homemarket = homemarket;
    event_params.environment = data?.enviroment || data?.environment || 'production';
    event_params.login = login;
    
    
    const dto = new BusinessInteractEventDto();
    dto.event = "interacciones";
    dto.event_params = event_params;

    if (user_props && Object.keys(user_props).length) {
        const user_properties = new BusinessUserPropertiesDto();
        user_properties.pas_dni_hashed = SHA256(user_props.pas_dni).toString();
        if (user_props.birthday) {
            user_properties.birthday = user_props.birthday;
        }
        user_properties.user_type = user_props.user_type;

        dto.user_properties = user_properties;
    }
    
    return dto;
}

export const BusinessInteractPaymentEvent = (data: any): BusinessInteractPaymentEventDto => {
    const { categoria, accion, etiqueta, micrositio, negocio, page_path, page_type, instance = 'IS', homemarket, environment, corpo } = data;

    const event_params = new BusinessInteractPaymentEventParamsDto();
    event_params.evento_interactivo_categoria = categoria;
    event_params.evento_interactivo_accion = accion;
    event_params.evento_interactivo_etiqueta = etiqueta;
    event_params.app = false;
    event_params.environment = environment;
    event_params.corp = corpo || false;
    event_params.page_path = page_path;
    event_params.page_type = page_type;
    event_params.negocio = negocio;
    event_params.micrositio = micrositio;
    event_params.homemarket = homemarket;
    event_params.buy_instance = instance;
    event_params.login = corpo || false;
    event_params.currency = data?.currency || 'CLP';
    event_params.initial_date = data?.initial_date || '';
    event_params.end_date = data?.end_date || '';
    event_params.from_iata = data?.from_iata || '';
    event_params.to_iata = data?.to_iata || '';
    event_params.trip_type = data?.trip_type || '';
    event_params.time = data?.time || '';
    event_params.passengers_adult = data?.passengers_adult || 0;
    event_params.passengers_child = data?.passengers_child || 0;
    event_params.passengers_infant = data?.passengers_infant || 0;
    event_params.passengers_pet = data?.passengers_pet || 0;
    event_params.pax = data?.pax || 0;
    event_params.full_trip = data?.full_trip || '';

    const dto = new BusinessInteractPaymentEventDto();
    dto.event = "interacciones";
    dto.event_params = event_params;

    return dto;
}
